import React, { useEffect } from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page Not Found | MediaCrypto";
    let meta = document.querySelector('meta[name="robots"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "robots";
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", "noindex, follow");
    return () => {
      meta.setAttribute("content", "index, follow");
    };
  }, []);

  return (
    <div className="pt-32 pb-20 text-center px-6">
      <h1 className="font-display font-bold text-4xl text-[var(--text-primary)]">404 — Page Not Found</h1>
      <p className="mt-4 text-[var(--text-secondary)] max-w-md mx-auto">
        The page you're looking for doesn't exist or may have been moved.
      </p>
      <Link to="/" className="inline-block mt-8 text-yellow-400 hover:underline font-mono text-sm uppercase tracking-widest">
        ← Back to Home
      </Link>
    </div>
  );
}